



























































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { Area, Section, Village } from "../core/interface";
import { ChartData, ChartSettings, FormatName, FormatNameValues, IncomeTaxObject, DividendTaxObject } from "../core/chart-models";
import { ApiService } from "../api/generated/api.service";
import { ApiClient } from "../api/api-client";
import { GraphNameValues, GraphName } from "../api/generated/api-types";
import {
    getChartObj, getPercentageDiff,
    getPercentagShift, getRange, getPackage,
    getPercentage, addInterest
} from "../core/chart-methods";
import { AreasData, SectionData, getGraphSettings, VillageData } from "../core/localData";
import chart from '../components/chart.vue';
import radiobox from '../components/radiobox.vue';
import checkbox from '../components/checkbox.vue';
import selectbox from '../components/selectbox.vue';
import tabs from '../components/tabs.vue';
import chartHeader from '../components/chart-header.vue';
import d3 from 'd3';
import html2canvas from 'html2canvas';
import download from 'downloadjs';

@Component({
    components: {
        chartHeader,
        tabs,
        chart,
        radiobox,
        checkbox,
        selectbox
    }
})
export default class Graph extends Vue {
    private api = new ApiService(new ApiClient());
    private villages: Village[] = VillageData['viimsi'];
    private sections: Section[] = SectionData;
    private settings: ChartSettings = getGraphSettings();
    private chartConfig: ChartData | null = null;
    private graphSelector = [];
    private toohoiveLocations = getGraphSettings('tulude-laekumine-palgagrupiti').uiConfig.customRadio;
    private registreerimisedView = getGraphSettings('demograafilised-andmed-registreeritud').uiConfig.customRadio;
    private registreerimised = getGraphSettings('demograafilised-andmed-registreeritud').uiConfig.customCheck;
    private dividends = [{label: 'Pot. dividenditulud', value: 'Pot. dividenditulud'}];
    private selected = {
        gender: 0,
        viewType: 0,
        registreerimisedView: this.registreerimisedView[0],
        toohoiveLocationsSelected: [...this.toohoiveLocations],
        registreerimisedSelected: [...this.registreerimised],
        dividendsSelected: []
    }
    private data: any = {};
    private SelectedFIT = {
        income: {
            countIncrease: 20,
            percentIncrease: 2
        },
        dividend: {
            taxPercent: 2,
            percentIncrease: 5
        }
    }

    private showLocation: boolean = false;
    private selectedLocation: string = 'viimsiValdJaMujalBrutotuludKokku';

    get getAreaFromUrl(): Area { return (this.$route.params as any).area }
    get getVillageFromUrl(): Village { return this.villages.find((village: any) =>  (this.$route.params as any).village === village.value) || {name: 'Kokku', value: 'kokku'} }
    get getSectionFromUrl(): Section { return this.sections.find((section: Section) => (this.$route.params as any).section === section.value) || this.sections[0]; }
    get getGraphNameFromUrl(): string { return (this.$route.params as any).graphName as string }
    get isMobile(): boolean { return (window as any).outerWidth < 768 } // only check during component render

    mounted() {
        if(this.isMobile && 'orientation' in screen) {
            (screen as any).orientation.lock('landscape');
        }
        this.genChart();
    }
    destroyed() {
        if('orientation' in screen) {
            (screen as any).orientation.unlock();
        }
    }
    @Watch('$route') routeChanged(newVal: any, oldVal: any) {
        this.selected.gender = this.selected.viewType = 0;
        this.selected.toohoiveLocationsSelected = [...this.toohoiveLocations];
        this.selected.registreerimisedSelected = [...this.registreerimised];
        this.genChart();
    }
    async genChart() {
        const graphValue:string = this.getGraphNameFromUrl;
        if(this.getGraphNameFromUrl === 'fit') { this.genFITChart(); return; }
        const settings = Object.assign({}, getGraphSettings(graphValue));

        this.settings = this.getProcessedSettings(settings, graphValue);
        this.graphSelector = (this.settings.uiConfig.graphSelector) ? this.settings.uiConfig.graphSelector : []; // find a better way

        const barData: any[] = await this.getData(this.settings.y.graphName);
        const lineData: any[] = (this.settings.y2) ? await this.getData(this.settings.y2[0].graphName) : null; // limited support

        const filteredBarData = this.getFilteredBarData(barData, graphValue, this.selected);
        const filteredLineData = this.getFilteredLineData(lineData, graphValue, this.selected);
        this.chartConfig = getPackage(filteredBarData, filteredLineData, this.settings, this.selected.viewType, graphValue);
    }
    async genFITChart() {
        const graphValue:string = this.getGraphNameFromUrl;
        const settings = Object.assign({}, getGraphSettings(graphValue));
        this.settings = this.getProcessedSettings(settings, graphValue);

        let barData: any[]  = [];
        const incomeTaxData = await this.getData(GraphNameValues.TULUDE_LAEKUMISE_SUMMA);
        const dividendTaxData = await this.getData(GraphNameValues.DIVIDENDI_TULU_ÜLDISELT);

        const yearLatest = incomeTaxData.sort((a: any, b: any) => (!b['aasta']) ? 1 : (a['aasta'] > b['aasta']) ? 1 : ((b['aasta'] > a['aasta']) ? -1 : 0))[incomeTaxData.length-1]['aasta'];

        const incomeTaxDataLatestYearObj = incomeTaxData.filter((item: any) =>  item['aasta'] === yearLatest);
        const baseIncomeTaxObj: IncomeTaxObject = this.getFITBaseIncomeTaxObj(incomeTaxDataLatestYearObj); // Get last year data
        const estimatedIncometaxArr: IncomeTaxObject[] = this.genFITEstimatedIncomeTaxArr(baseIncomeTaxObj, 4);

        barData = [baseIncomeTaxObj, ...estimatedIncometaxArr];

        if(this.selected.dividendsSelected.length) {
            const dividendTaxDataLatestYearObj = dividendTaxData.filter((item: any) =>  item['aasta'] === yearLatest);
            const baseDividendTaxObj: DividendTaxObject = this.getFITBaseDividendTaxObj(dividendTaxDataLatestYearObj);
            const estimatedDividendtaxArr: DividendTaxObject[] = this.genFITEstimatedDividendTaxArr(baseDividendTaxObj, 4);
            barData = [...barData, baseDividendTaxObj, ...estimatedDividendtaxArr];
        }
        this.chartConfig = getPackage(barData, [], settings, this.selected.viewType, graphValue);
    }
    async getData(graphName: GraphName) {
        if(this.data[graphName]) { return this.data[graphName]; }
        const res = await this.api.analysis.getGraphData({graphName: graphName});
        return this.data[graphName] = res.data;
    }
    getProcessedSettings(settings: ChartSettings, graphValue: string): ChartSettings {
        switch(graphValue) {
            case 'tulude-jaotus-arv':
                if(!this.selected.dividendsSelected.length && Array.isArray(settings.y2)) {
                    settings.y2 = settings.y2.filter((item:any) => item.label !== 'dividenditulu2')
                }
                break;
            case 'tulude-jaotus-summa':
                if(!this.selected.dividendsSelected.length && Array.isArray(settings.y2)) {
                    settings.y2 = settings.y2.filter((item:any) => item.label !== 'dividenditulu2')
                }
                break;
            default:
                break;
        }
        return settings;
    }
    getFilteredBarData(data: any[], graphValue: string, selected: any): any[] {
        if(selected.gender !== 0 && (graphValue === 'demograafilised-andmed' || graphValue === 'demograafilised-andmed-vanus')) {
            const genderChar = (selected.gender === 1) ? 'M' : 'N';
            data = data.filter((item: any) => genderChar === item['sugu']);
        } else if (selected.gender !== 0) {
            data = data.filter((item: any) => selected.gender === item['sugu'])
        }
        switch (graphValue) {
            case 'maksutulud':
                return data.filter((item: any) => item['tüüp'] === 'Maksutulud');
            case 'toohoive-asukoht':
                let selected = this.selected.toohoiveLocationsSelected.map((item: any) => item.value);
                return data.filter((item: any) => selected.indexOf(item['asukohaGrupp']) !== -1);
            case 'tulude-laekumine-palgagrupiti':
                data = data.map((item: any) => Object.assign(item, { brutotuludKokku: item[this.selectedLocation] }));
                return data;
            case 'demograafilised-andmed-registreeritud':
                let key = this.selected.registreerimisedView.value;
                if(key === 'uuedRegistreerunudInimesed' && this.selected.registreerimisedSelected.length === 1) { key = this.selected.registreerimisedSelected[0].value }
                data = data.map((item: any) => {
                    item['inimesed'] = item[key];
                    return item;
                })
                return data;
            case 'tulude-jaotus-summa':
                const refined = data.reduce((acc, curr) => {
                    const { aasta , asukohtAl10, dividendiTulu, palgaTulu, palgatulu1116, dividenditulu2 } = curr;
                    const tootasu = {aasta , asukohtAl10, summa: palgaTulu, type: 'Palgatulu', palgatulu1116, dividenditulu2}; //palgatulu1116 & dividenditulu2 - for y2
                    const dividend = {aasta , asukohtAl10, summa: dividendiTulu || 0, type: 'Dividenditulu'}; //do not include palgatulu1116 & dividenditulu2 .. will be doubled
                    acc = [...acc, tootasu, dividend];
                    return acc;
                }, []);
                if(this.getVillageFromUrl.value === 'kokku') { return refined; }
                return refined.filter((item: any) => item['asukohtAl10'] === this.getVillageFromUrl.name)
            case 'tulude-jaotus-arv':
                const arvRefined = data.reduce((acc, curr) => {
                    const { aasta , asukohtAl10, isikuteArvDividendiTulu, isikuteArvPalgaTulu, isikuteArvPalgaJaDividendiTulu, palgatulu1116, dividenditulu2 } = curr;
                    const arvDividend = {aasta, asukohtAl10, summa: isikuteArvDividendiTulu || 0, type: 'Dividenditulu saajate arv', palgatulu1116, dividenditulu2} //palgatulu1116 & dividenditulu2 - for y2
                    const arvPalk = {aasta, asukohtAl10, summa: isikuteArvPalgaTulu || 0, type: 'Palgatulu saajate arv'}
                    const arvPalkDividend = {aasta, asukohtAl10, summa: isikuteArvPalgaJaDividendiTulu || 0, type: 'Palga ja dividendi saajate arv'}
                    acc = [...acc, arvDividend, arvPalk, arvPalkDividend];
                    return acc;
                }, []);
                if(this.getVillageFromUrl.value === 'kokku') { return arvRefined; }
                return arvRefined.filter((item: any) => item['asukohtAl10'] === this.getVillageFromUrl.name)
            default:
                return data;
        }
    }
    getFilteredLineData(data: any[], graphValue: string, selected: any): any[] {
        if(!data) return data;
        switch (graphValue) {
            case 'tulubaas':
                // console.log(data)
                return data;
            case 'maksutulud':
                // console.log(data)
                return data;
            case 'toohoive':
                return (selected.gender === 0) ? data : data.filter((item: any) => selected.gender === item['sugu']);
            case 'tulude-jaotus-summa':
                if(this.getVillageFromUrl.value === 'kokku') { return data; }
                return data.filter((item: any) => item['asukohtAl10'] === this.getVillageFromUrl.name)
            case 'tulude-jaotus-arv':
                if(this.getVillageFromUrl.value === 'kokku') { return data; }
                return data.filter((item: any) => item['asukohtAl10'] === this.getVillageFromUrl.name)
        }
        return data;
    }

    downloadGraphImage() {
        try {
            this.sendGAEvent('Graph', 'click', 'Download image', this.settings.title);
            let style = "\n";
            const availableStyleSheets: any[] = Object.keys(document.styleSheets).map((key: any) => {
                return document.styleSheets[key]
            }).filter((sheet: any) => !sheet.href || sheet.href.indexOf(window.location.hostname) !== -1);

            // get available styles that are associated with c3
            availableStyleSheets.forEach((sheet) => {
                if (sheet.cssRules) {
                    Object.keys(sheet.cssRules).map((key: any) => {
                        return sheet.cssRules[key]
                    }).forEach((rule) => {
                        if(rule.selectorText && rule.selectorText.indexOf('c3') !== -1) {
                            style += rule.cssText + '\n';
                        }
                    });
                }
            });

            let charts = d3.select('.charts'),
                chartsNode = (charts.node() as any);

            // TODO when html2canvas starts supporting onclone(https://github.com/niklasvh/html2canvas/issues/1403) again, then use cloned document to set all this
            charts.select('.legend-list').classed('legend-list--show-all', true); // show all legends
            charts.select('.chart__content svg').classed('c3', true).insert('defs', ':first-child');
            charts.select('.chart__content svg defs').append('style').attr('type', 'text/css').html(style); // apply styles

            html2canvas(chartsNode, {
                allowTaint: true,
                useCORS: true,
                foreignObjectRendering: false,
                width: chartsNode.offsetWidth,
                height: chartsNode.offsetHeight,
                x: chartsNode.offsetLeft,
                y: chartsNode.offsetTop,
                scrollY: chartsNode.scrollY,
                scrollX: chartsNode.scrollX,
                logging: false
            }).then((canvas: any) => {
                download((canvas as any).toDataURL('image/png'), `${this.settings.title}.png`, 'image/png'); // download file
                charts.select('.chart__content svg defs').remove(); // remove styles again
                charts.select('.legend-list').classed('legend-list--show-all', false); // hide all legends again
            });
        } catch(error) {
            alert('Graafiku pildi allalaadimiseks kasuta palun värskemat veebilehitseja tehnoloogiat - nt Google Chrome, Mozilla Firefox, Microsoft Edge või Safari.');
        }
    }

    onViewTypeChanged(viewType: number) {
        this.selected.viewType = viewType;
        this.genChart();
    }
    onRegisterViewTypeChanged(view: string) {
        this.selected.registreerimisedView = this.registreerimisedView.filter((item:any) => item.value === view)[0];
        this.genChart();
    }
    onregistreerimisedChanged(event: any) {
        if(this.selected.registreerimisedSelected.length === 0) {
            setTimeout(() => event.target.click(), 0);
        }
        this.genChart();
    }
    onGenderChanged(gender: number) {
        this.selected.gender = +gender;
        this.genChart();
    }
    onToohoiveLocationChanged(event: any) {
        if(this.selected.toohoiveLocationsSelected.length === 0) {
            setTimeout(() => event.target.click(), 0);
        }
        this.genChart();
    }
    onLocationChanged(location: string) {
        this.sendGAEvent('Graph', 'change', 'Location', location);
        this.selectedLocation = location;
        this.genChart();
    }
    onSectionChanged(section: any) {
        this.sendGAEvent('Graph', 'change', 'Section', section);
        this.$router.replace(`/graphs/${this.getAreaFromUrl}/kokku/${section.value}/${section.defaultGraphName}`);
    }
    onGraphChanged(graphName: string) {
        this.sendGAEvent('Graph', 'change', 'Graph', graphName);
        if(this.getSectionFromUrl.value === 'tulude-jaotus') {
            this.$router.replace(`/graphs/${this.getAreaFromUrl}/${this.getVillageFromUrl.value}/${this.getSectionFromUrl.value}/${graphName}`);
        } else {
            this.$router.replace(`/graphs/${this.getAreaFromUrl}/kokku/${this.getSectionFromUrl.value}/${graphName}`);
        }
    }
    onVillageChanged(village: any) {
        this.sendGAEvent('Graph', 'change', 'Village', village);
        this.$router.replace(`/graphs/${this.getAreaFromUrl}/${village.value}/${this.getSectionFromUrl.value}/${this.getGraphNameFromUrl}`);
    }
    onDividendChanged() {
        this.genChart();
    }
    getFITFormValues (submitEvent: any) {
        this.SelectedFIT.income.countIncrease = +submitEvent.target.elements.count.value.replace(/,/g, '.');
        this.SelectedFIT.income.percentIncrease = +submitEvent.target.elements.percent.value.replace(/,/g, '.');
        this.SelectedFIT.dividend.percentIncrease = 5;
        this.genChart();
    }
    getFITBaseIncomeTaxObj(apiData: any[]): IncomeTaxObject {
        return (
            apiData
                .reduce((acc: IncomeTaxObject, curr:any) => {
                    if(!acc.tax) {
                        acc = {
                            tax: curr['brutotulust116'],
                            people: curr['grupisIsikuid'],
                            year: curr['aasta'],
                            gender: 0,
                            ageGroup: null,
                            type: 'FIT',
                            taxPerPerson: 0,
                            income: 0
                        }
                    } else {
                        acc.tax += curr['brutotulust116'];
                        acc.people += curr['grupisIsikuid'];
                        acc.taxPerPerson = acc.tax / acc.people;
                    }
                    return acc;
                }, {})
        )
    }
    getFITBaseDividendTaxObj(apiData: any[]): DividendTaxObject {
        return (
            apiData
                .reduce((acc: DividendTaxObject, curr: any) => {
                    if(!acc.tax) {
                        acc = {
                            tax: getPercentage(curr['dividendideSumma'], this.SelectedFIT.dividend.taxPercent),
                            year: curr['aasta'],
                            gender: 0,
                            income: curr['dividendideSumma'],
                            type: 'Dividend',
                            taxPerPerson: 0
                        }
                    } else {
                        acc.income += curr['dividendideSumma'];
                        acc.tax += getPercentage(curr['dividendideSumma'], this.SelectedFIT.dividend.taxPercent);
                    }
                    return acc;
                }, {})
        )
    }
    genFITEstimatedIncomeTaxArr({people, tax, taxPerPerson, year, gender}: IncomeTaxObject, steps: number): IncomeTaxObject[] {
        return (
            Array(steps)
                .fill(undefined)
                .map((item: any) => {
                    year += 1;
                    people  += this.SelectedFIT.income.countIncrease;
                    taxPerPerson = addInterest(taxPerPerson , this.SelectedFIT.income.percentIncrease);
                    tax = taxPerPerson * people;
                    return { tax, taxPerPerson, people, year, gender, ageGroup: null, type: 'FIT', income: 0 }
                }))
    }
    genFITEstimatedDividendTaxArr({year, income, tax, gender}: DividendTaxObject, steps: number): DividendTaxObject[] {
        return (
            Array(steps)
                .fill(undefined)
                .map((item: any) => {
                    year += 1;
                    income = addInterest(income , this.SelectedFIT.dividend.percentIncrease);
                    tax = addInterest(tax , this.SelectedFIT.dividend.percentIncrease);
                    return { gender, income, tax, year, type: 'Dividend', taxPerPerson: 0 }
                })
        )
    }

    private sendGAEvent(category?: string, action?: string, label?: string, value?: string): void {
        let trackObj: {
            category?: string,
            action?: string,
            label?: string,
            value?: string
        } = {};
        if(category) trackObj.category = category;
        if(action) trackObj.action = action;
        if(label) trackObj.label = label;
        if(value) trackObj.value = value;
        Vue.gtm.trackEvent(trackObj);
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/graph.vue